import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "m_menu_top D_none" }
const _hoisted_3 = { class: "utility_wrap D_none" }
const _hoisted_4 = { class: "m_btn_wrap" }
const _hoisted_5 = { class: "_flex after_login" }
const _hoisted_6 = { class: "user_btn" }
const _hoisted_7 = { class: "elips_1" }
const _hoisted_8 = { class: "m_btn_wrap" }
const _hoisted_9 = { class: "depth_02" }
const _hoisted_10 = { class: "depth_02" }
const _hoisted_11 = { class: "depth_02" }
const _hoisted_12 = { class: "depth_02" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.state.isLogin)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[12] || (_cache[12] = _createElementVNode("a", {
                href: "",
                class: "icon_wrap center_btn go_center"
              }, [
                _createElementVNode("img", {
                  src: "img/center.png",
                  alt: "다시함께상담센터"
                })
              ], -1)),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_router_link, {
                  to: "/login",
                  class: "m_btn _blue"
                }, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode("로그인", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "/join",
                  class: "m_btn _gray"
                }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode("회원가입", -1)
                  ]))]),
                  _: 1
                })
              ])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[13] || (_cache[13] = _createElementVNode("img", {
                    src: "img/user_icon.png",
                    alt: ""
                  }, null, -1)),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.user.userInfo.name) + "님", 1)
                ]),
                _cache[14] || (_cache[14] = _createElementVNode("a", {
                  href: "",
                  class: "icon_wrap center_btn go_center"
                }, [
                  _createElementVNode("img", {
                    src: "img/center.png",
                    alt: "다시함께상담센터"
                  })
                ], -1))
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_router_link, {
                  to: "/mypage",
                  class: "m_btn"
                }, {
                  default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                    _createTextVNode("마이페이지", -1)
                  ]))]),
                  _: 1
                }),
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
                  class: "m_btn _gray"
                }, "로그아웃")
              ])
            ], 64))
      ])
    ]),
    _cache[31] || (_cache[31] = _createElementVNode("div", { class: "nav_bg" }, null, -1)),
    _createElementVNode("ul", {
      class: _normalizeClass(["depth_01", [_ctx.state.customClass ? '_white' : '']])
    }, [
      _createElementVNode("li", null, [
        _cache[19] || (_cache[19] = _createElementVNode("button", { class: "_intro" }, "소개", -1)),
        _createElementVNode("ul", _hoisted_9, [
          _createElementVNode("li", {
            class: _normalizeClass([_ctx.state.currentPath === '/intro?type=1' ? 'active' : ''])
          }, [
            _createVNode(_component_router_link, {
              to: "/intro?type=1",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.global.setIntroTab(1)))
            }, {
              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                _createTextVNode("반성매매 시민참여 플랫폼", -1)
              ]))]),
              _: 1
            })
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass([_ctx.state.currentPath === '/intro?type=2' ? 'active' : ''])
          }, [
            _createVNode(_component_router_link, {
              to: "/intro?type=2",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.global.setIntroTab(2)))
            }, {
              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                _createTextVNode("다시함께상담센터", -1)
              ]))]),
              _: 1
            })
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass([_ctx.state.currentPath === '/intro?type=3' ? 'active' : ''])
          }, [
            _createVNode(_component_router_link, {
              to: "/intro?type=3",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.global.setIntroTab(3)))
            }, {
              default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                _createTextVNode("자주 묻는 질문", -1)
              ]))]),
              _: 1
            })
          ], 2)
        ])
      ]),
      _createElementVNode("li", null, [
        _cache[22] || (_cache[22] = _createElementVNode("button", { class: "_report" }, "시민제보창", -1)),
        _createElementVNode("ul", _hoisted_10, [
          _createElementVNode("li", {
            class: _normalizeClass([_ctx.state.currentPath === '/report?type=1' ? 'active' : ''])
          }, [
            _createVNode(_component_router_link, {
              to: "/report?type=1",
              onClick: _cache[4] || (_cache[4] = ($event: any) => {
                                _ctx.global.setReportTab(1);
                                _ctx.state.currentPath = '/report?type=1';
                            })
            }, {
              default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                _createTextVNode(" 성매매 의심 업소 제보 ", -1)
              ]))]),
              _: 1
            })
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass([_ctx.state.currentPath === '/report?type=2' ? 'active' : ''])
          }, [
            _createVNode(_component_router_link, {
              to: "/report?type=2",
              onClick: _cache[5] || (_cache[5] = ($event: any) => {
                                _ctx.global.setReportTab(2);
                                _ctx.state.currentPath = '/report?type=2';
                            })
            }, {
              default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                _createTextVNode(" 성매매 알선 광고 제보 ", -1)
              ]))]),
              _: 1
            })
          ], 2)
        ])
      ]),
      _createElementVNode("li", null, [
        _cache[27] || (_cache[27] = _createElementVNode("button", { class: "_activity" }, "시민참여 활동", -1)),
        _createElementVNode("ul", _hoisted_11, [
          _createElementVNode("li", {
            class: _normalizeClass([_ctx.state.currentPath === '/board?type=1' ? 'active' : ''])
          }, [
            _createVNode(_component_router_link, {
              to: "/board?type=1",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.global.setBoardTab(1)))
            }, {
              default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                _createTextVNode("반성매매 시민활동", -1)
              ]))]),
              _: 1
            })
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass([_ctx.state.currentPath === '/board?type=2' ? 'active' : ''])
          }, [
            _createVNode(_component_router_link, {
              to: "/board?type=2",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.global.setBoardTab(2)))
            }, {
              default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                _createTextVNode("캠페인·이벤트", -1)
              ]))]),
              _: 1
            })
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass([_ctx.state.currentPath === '/board?type=3' ? 'active' : ''])
          }, [
            _createVNode(_component_router_link, {
              to: "/board?type=3",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.global.setBoardTab(3)))
            }, {
              default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                _createTextVNode(" 참여하고 싶은 ", -1),
                _createElementVNode("br", { class: "none_1024" }, null, -1),
                _createTextVNode(" 반성매매 활동 제안 ", -1)
              ]))]),
              _: 1
            })
          ], 2),
          (_ctx.user.isLogin())
            ? (_openBlock(), _createElementBlock("li", {
                key: 0,
                class: _normalizeClass([_ctx.state.currentPath === '/board?type=4' ? 'active' : ''])
              }, [
                _createVNode(_component_router_link, {
                  to: "/board?type=4",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.global.setBoardTab(4)))
                }, {
                  default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                    _createTextVNode("액션 시민 활동", -1)
                  ]))]),
                  _: 1
                })
              ], 2))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("li", null, [
        _cache[30] || (_cache[30] = _createElementVNode("button", { class: "_news" }, "감시소식", -1)),
        _createElementVNode("ul", _hoisted_12, [
          _createElementVNode("li", {
            class: _normalizeClass([_ctx.state.currentPath === '/news' ? 'active' : ''])
          }, [
            _createVNode(_component_router_link, { to: "/news" }, {
              default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                _createTextVNode("감시소식", -1)
              ]))]),
              _: 1
            })
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass([_ctx.state.currentPath === '/archive' ? 'active' : ''])
          }, [
            _createVNode(_component_router_link, { to: "/archive" }, {
              default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                _createTextVNode("자료집", -1)
              ]))]),
              _: 1
            })
          ], 2)
        ])
      ])
    ], 2)
  ]))
}